import { AnyObjectSchema } from 'yup';

import { AnyDocument, WorkflowStepFormFieldBlock } from '../../../types';
import { getValidationSchemaForForm } from '../../../utils/forms';

export const buildBlockSchema = (
  formFieldBlocks: WorkflowStepFormFieldBlock[],
  rootDocument: AnyDocument | undefined,
  valueGetter: (key: string) => unknown,
): AnyObjectSchema =>
  getValidationSchemaForForm(
    formFieldBlocks,
    rootDocument,
    valueGetter,
  ).required();
